import { useCallback } from 'react';
import {
  useQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  OperationVariables,
  QueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AllInfluencerManagers.graphql';
import { Query } from '../../__generated__/globalTypes';

export const useAllInfluencerManagersQuery = (options?: QueryHookOptions<Query>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAllInfluencerManagersLazyQuery = (
  options?: LazyQueryHookOptions<Query>
): QueryResult<Query> & { getAllInfluencerManagersQuery: LazyQueryExecFunction<Query, OperationVariables> } => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  // TODO: should be getAllInfluencerManagers
  const [getAllInfluencerManagersQuery, result] = useLazyQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAllInfluencerManagersQuery, ...result };
};

export const useAllInfluencerManagersPromiseQuery = () => {
  const client = useApolloClient();

  const getAllInfluencerManagers = useCallback(
    (options?: Omit<QueryOptions<Record<string, unknown>, Query>, 'query'>) =>
      client.query<Query>({ ...options, query: QUERY }),
    [client]
  );

  return { getAllInfluencerManagers };
};
